import { SXStyleSheet } from '@/utils';

// Masse und Rahmen-Stile liegen seit der Nacharbeit Beratungsstrecke
// (27.10.2026) in den gemeinsamen Rahmen-Bausteinen (`@/components/ui/Rahmen`).
// Hier bleibt nur, was allein die CRM-Sidebar braucht.
export {
  SIDEBAR_WIDTH_COLLAPSED,
  SIDEBAR_WIDTH_EXPANDED,
  APP_BAR_HEIGHT,
  BRAND_LOCKUP_HEIGHT,
} from '@/components/ui/Rahmen/style';

const style = SXStyleSheet.create({
  itemsContainer: {
    width: '100%',
    flex: 1,
    paddingTop: '48px',
    overflowY: 'auto',
    overflowX: 'hidden',
    '&::-webkit-scrollbar': {
      width: '4px',
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: 'navigation.scroll',
      borderRadius: '2px',
    },
  },
  noLogo: {
    pt: 7,
  },
});

export default style;
